import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import { loginUserCheck, logoutUser, brandUpdateById } from "../redux/actions";

class AdminEditBrand extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      img: "",
      photo: "",
      title: "",
      order: 0,
      oldOrder: 0,
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    let params = this.getParams();
    this.setState({
      id: params.id,
      img: params.img + "&token=" + params.token,
      title: params.title,
      order: params.order,
      oldOrder: params.order,
    });
  }

  getParams() {
    const str = this.props.location.search;
    let objURL = {};
    str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), ($0, $1, $2, $3) => {
      objURL[$1] = $3;
    });
    return objURL;
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _onSubmit() {
    let oldImg = decodeURIComponent(this.state.img.substring(70, 95));
    let data = {
      img: this.state.photo,
      title: this.state.title,
      order: this.state.order,
      created_by: this.props.user,
    };
    if (this.state.title && this.state.order) {
      this.props.brandUpdateById(
        this.state.id,
        data,
        oldImg,
        this.state.oldOrder
      );
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-editbrand">
          <Nav active="product" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>สินค้า: แก้ไขยี่ห้อ</h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <form action="" className="photo">
                    <div className="brand-title">
                      <p>โลโก้ยี่ห้อ (320x235px)</p>
                    </div>
                    <div className="filename">
                      <p>{this.state.photo.name}</p>
                    </div>
                    <div className="photo-input">
                      <input
                        id="photo"
                        type="file"
                        name="photo"
                        accept="image/*"
                        hidden
                        onChange={(event) => this._onHandleChange(event)}
                      />
                      <label htmlFor="photo">เลือกรูปภาพ</label>
                    </div>
                    <div className="oldphoto">
                      <img src={this.state.img} alt="brand" />
                    </div>
                  </form>
                  <form className="text">
                    <p>ชื่อยี่ห้อ</p>
                    <input
                      type="text"
                      name="title"
                      onChange={(event) => this._onHandleChange(event)}
                      value={this.state.title}
                    ></input>
                    <p>อันดับ</p>
                    <input
                      type="number"
                      name="order"
                      value={this.state.order}
                      onChange={(event) => this._onHandleChange(event)}
                      style={{ width: "90px" }}
                    />
                  </form>
                  <div className="action-button">
                    {this.props.loading ? (
                      <div>
                        <p style={{ textAlign: "left" }}>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        <Button type="primary" onClick={() => this._onSubmit()}>
                          บันทึก
                        </Button>
                        <Button onClick={() => window.history.back()}>
                          กลับ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, brand }) => {
  return {
    user: auth.user,
    loading: brand.loading,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  brandUpdateById,
})(AdminEditBrand);
